// Revelio Labs palettes
export const BluePalette = [
  '#D8F2FB', //'color/blue/50',
  '#B2E5F7', //'color/blue/100',
  '#96DDF5', //'color/blue/200',
  '#7AD3F2', //'color/blue/300',
  '#5CC9EF', //'color/blue/400',
  '#3DBFEC', //'color/blue/500',
  '#20B7E9', //'color/blue/600',
  '#149ECC', //'color/blue/700',
  '#1181A7', //'color/blue/800',
  '#0D6582', //'color/blue/900',
];

export const PinkPalette = [
  '#FEF6FB', //'color/pink/50',∂
  '#FBE9F5', //'color/pink/100',
  '#F8D3EA', //'color/pink/200',
  '#F5C1E2', //'color/pink/300',
  '#F2ABD8', //'color/pink/400',
  '#EE95CD', //'color/pink/500',
  '#E454AF', //'color/pink/600',
  '#CA208C', //'color/pink/700',
  '#84155B', //'color/pink/800',
  '#420B2E', //'color/pink/900',
];

export const PrimaryPalette = [
  '#EBF9F1', //'color/primary/50',
  '#DBF3E4', //'color/primary/100',
  '#B0E8C8', //'color/primary/200',
  '#89DCAD', //'color/primary/300',
  '#65D294', //'color/primary/400',
  '#3DC679', //'color/primary/500',
  '#2FA261', //'color/primary/600',
  '#237647', //'color/primary/700',
  '#174F2F', //'color/primary/800',
  '#0C2718', //'color/primary/900',
];

export const SecondaryPalette = [
  '#E6EBF4', //'color/secondary/50',
  '#CDD7EA', //'color/secondary/100',
  '#9BAFD4', //'color/secondary/200',
  '#6987BF', //'color/secondary/300',
  '#43639E', //'color/secondary/400',
  '#2D426A', //'color/secondary/500',
  '#243656', //'color/secondary/600',
  '#1B2840', //'color/secondary/700',
  '#121B2B', //'color/secondary/800',
  '#090D15', //'color/secondary/900',
];

export const NeutralPalette: string[] = [
  '#FFFFFF', //'color/neutral/0',
  '#F7FAFC', //'color/neutral/50',
  '#EDF2F7', //'color/neutral/100',
  '#E2E8F0', //'color/neutral/200',
  '#CBD5E0', //'color/neutral/300',
  '#A0AEC0', //'color/neutral/400',
  '#718096', //'color/neutral/500',
  '#4A5568', //'color/neutral/600',
  '#2D3748', //'color/neutral/700',
  '#1A202C', //'color/neutral/800',
  '#171923', //'color/neutral/900',
  '#000000', //'color/neutral/1000',
] as const;

export const NegativePalette = [
  '#FFF5F5', // color/negative/50
  '#FED7D7', // color/negative/100
  '#FEB2B2', // color/negative/200
  '#FC8181', // color/negative/300
  '#F56565', // color/negative/400
  '#E53E3E', // color/negative/500
  '#C53030', // color/negative/600
  '#9B2C2C', // color/negative/700
  '#822727', // color/negative/800
  '#63171B', // color/negative/900
];

export const NoticePalette = [
  '#FFFFF0', // color/notice/50
  '#FEFCBF', // color/notice/100
  '#FAF089', // color/notice/200
  '#F6E05E', // color/notice/300
  '#ECC94B', // color/notice/400
  '#D69E2E', // color/notice/500
  '#B7791F', // color/notice/600
  '#975A16', // color/notice/700
  '#744210', // color/notice/800
  '#5F370E', // color/notice/900
];
